module.exports = __webpack_public_path__ + "static/media/vegetarian.63c14dda.svg";